import React from 'react';
import './Settlements.css';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useRef } from 'react';
import Select from 'react-select';
import { Tooltip } from 'reactstrap';
import { Row, Col } from 'react-bootstrap';
import Layout from '../NewHeader/Layout';


const Settlements = () => {
  const history = useHistory();
  const shopName= localStorage.getItem('shopName');
  const [suppliers, setSuppliers] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedSupplier, setSelectedSupplier] = useState(null); // State to hold the selected supplier
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [paidAmount, setPaidAmount] = useState(""); 
  const [remarks, setRemarks] = useState(""); 
   const [tables, setTables] = useState([]);
   const [ searchQuery,setSearchQuery] = useState('');
   const [show, setShow] = useState(false);
   const [showCreate, setShowCreate] = useState(false);

   const [tableD, setTableD] = useState({});
   const [ isEdit,setIsEdit ] = useState(false);
   const [puttooltipOpen, setPutToolTipOpen] = useState([]);
   const [deletetooltipOpen, setDeleteToolTipOpen] = useState([]);
   const [updateFormData, setUpdateFormData] = useState({
    id:null,
    supplier_name: "",
    paid_amount: "",
    remarks: "",
    shop_id:null
  });
  const fileInputRef = useRef(null);
  // const tablesData = [
  //   {
  //     id: 1,
  //     supplier_details: { supplier_name: 'Supplier A' },
  //     paid_amount: '$500.00',
  //     paid_time: '2023-11-01 10:30 AM',
  //     remarks: 'Payment received in full',
  //   },
  //   {
  //     id: 2,
  //     supplier_details: { supplier_name: 'Supplier B' },
  //     paid_amount: '$750.00',
  //     paid_time: '2023-11-02 02:45 PM',
  //     remarks: 'Partial payment made',
  //   },
  //   {
  //     id: 3,
  //     supplier_details: { supplier_name: 'Supplier C' },
  //     paid_amount: '$300.00',
  //     paid_time: '2023-11-03 11:15 AM',
  //     remarks: 'Payment pending verification',
  //   },
  //   {
  //     id: 4,
  //     supplier_details: { supplier_name: 'Supplier D' },
  //     paid_amount: '$450.00',
  //     paid_time: '2023-11-04 09:00 AM',
  //     remarks: 'Fully settled',
  //   },
  //   {
  //     id: 5,
  //     supplier_details: { supplier_name: 'Supplier E' },
  //     paid_amount: '$620.00',
  //     paid_time: '2023-11-05 04:30 PM',
  //     remarks: 'Invoice sent for payment',
  //   },
  //   {
  //     id: 6,
  //     supplier_details: { supplier_name: 'Supplier F' },
  //     paid_amount: '$820.00',
  //     paid_time: '2023-11-06 01:25 PM',
  //     remarks: 'Cleared after delay',
  //   },
  //   {
  //     id: 7,
  //     supplier_details: { supplier_name: 'Supplier G' },
  //     paid_amount: '$400.00',
  //     paid_time: '2023-11-07 08:30 AM',
  //     remarks: 'Awaiting final payment',
  //   },
  //   {
  //     id: 8,
  //     supplier_details: { supplier_name: 'Supplier H' },
  //     paid_amount: '$550.00',
  //     paid_time: '2023-11-08 03:10 PM',
  //     remarks: 'Invoice under review',
  //   },
  //   {
  //     id: 9,
  //     supplier_details: { supplier_name: 'Supplier I' },
  //     paid_amount: '$675.00',
  //     paid_time: '2023-11-09 05:45 PM',
  //     remarks: 'Confirmed received',
  //   },
  //   {
  //     id: 10,
  //     supplier_details: { supplier_name: 'Supplier J' },
  //     paid_amount: '$900.00',
  //     paid_time: '2023-11-10 12:00 PM',
  //     remarks: 'Settled with discount',
  //   },
  // ];
  
    useEffect(() => {
        fetchSuppliers();
        fetchSettlements();
      }, [selectedDate]);

      const fetchSuppliers = async () => {
        try {
           const shop = localStorage.getItem('ShopId');
           const token = localStorage.getItem('Token');
           const response = await axios.get(`${var_api}supplier-master/get/${shop}`, {
            headers: {
                Authorization: token, // Pass token in Authorization header
            },
        });
           console.log("response",response)
          const user =response.data;
          setSuppliers(user);
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
        }
      };


      const togglePutTooltip = (index) => {
        const putTooltipOpen = [...puttooltipOpen];
        putTooltipOpen[index] = !putTooltipOpen[index];
        setPutToolTipOpen(putTooltipOpen);
      };
      
      
      const toggleDeleteTooltip = (index) => {
        const deleteTooltipOpen = [...deletetooltipOpen];
        deleteTooltipOpen[index] = !deleteTooltipOpen[index];
        setDeleteToolTipOpen(deleteTooltipOpen);
      };

      const fetchSettlements = async () => {
        const shop = localStorage.getItem('ShopId');
           const token = localStorage.getItem('Token');
        try {
           const formattedDate = formatDate(selectedDate);
           const response = await axios.get(`${var_api}expense-log/get/${shop}/${formattedDate}`, {
            headers: {
                Authorization: token, // Pass token in Authorization header
            },
        });
           console.log("response",response)
          const user =response.data;
          setTables(user);
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
        }
      };

      const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };
const formatDate = (dateString) => {
    const [yyyy, mm, dd] = dateString.split('-');
    return `${dd}-${mm}-${yyyy}`;
};
      const handleSupplierSelectChange = (selectedOption) => {
        setSelectedSupplier(selectedOption); 
        // Update the selected supplier 
        setSelectedSupplierId(selectedOption.value);
      }; 

      const handleUpdateSupplierSelectChange = (selectedOption) => {
        setSelectedSupplier(selectedOption);  // Set the supplier name
        setUpdateFormData(prevData => ({
            ...prevData,
            supplier_id: selectedOption.value // Set the supplier_id
        }));
    };

      //post the form data
      const Submit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('Token');
      try{
        const response = await axios.post(`${var_api}expense-log/post`, {
            supplier_id: parseInt(selectedSupplierId), // Assuming you have selectedSupplierId state holding the selected supplier ID
            shop_id: localStorage.getItem('ShopId') || "",
            paid_amount: paidAmount,
            remarks: remarks,
            paid_date: getCurrentDate(), // Function to get current date
          },
          {
              headers: {
                  Authorization: token, // Include the token in the Authorization header
              },
          });
      
          if (response.status === 200) {
            Swal.fire({
              icon:"success",
              text:`Settlement Successfully`,
              confirmButtonColor:"#007500"
            })
            setSelectedSupplier("");
            setPaidAmount("");
            setRemarks("");
            fetchSettlements();
            setShowCreate(false);
            console.log('Data inserted successfully.')
  
        }
        } catch (error) {
          Swal.fire({
              icon:"error",
              text:`Failed to Create Supplier profile`,
              confirmButtonColor:"#007500"
            })
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('Token'); // Clear the invalid token
              history.push('/')// Redirect to the Sign-In page
            } else {
              console.error("Error fetching data:", error);
            }
          // Handle error scenario as needed
        }
      };

      const getCurrentDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1;
        let day = currentDate.getDate();
      
        // Add leading zero if month/day is single digit
        if (month < 10) {
          month = `0${month}`;
        }
        if (day < 10) {
          day = `0${day}`;
        }
      
        return `${day}-${month}-${year}`;
      };
      
      const getCurrentTime = () => {
        const currentTime = new Date();
        const hours = currentTime.getHours();
        const minutes = currentTime.getMinutes();
      
        // Add leading zero if minutes is single digit
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
      
        return `${hours}:${formattedMinutes}`;
      };
      const handlePaidAmountChange = (event) => {
        setPaidAmount(event.target.value); // Update the paid amount state
      };


      const handleUpdatePaidAmountChange = (e) => {
        const value = e.target.value;
        setUpdateFormData(prevData => ({
            ...prevData,
            paid_amount: value
        }));
    };
      

      const handleRemarksChange = (event) => {
        setRemarks(event.target.value); // Update the remarks state
      };


      const handleUpdateRemarksChange = (e) => {
        const value = e.target.value;
        setUpdateFormData(prevData => ({
            ...prevData,
            remarks: value
        }));
    };

    //reset the values
    const handleToReset = () => {
       setSelectedSupplier("");
            setPaidAmount("");
            setRemarks("");
    };

    const getTotalAmount = () => {
        let totalAmount = 0;
        tables.forEach((settlement) => {
          totalAmount += settlement.paid_amount;
        });
        return totalAmount.toFixed(2); // Ensure the total amount is formatted with 2 decimal places
      };


    //Go to home page
    const handleButtonClick = () => {
      history.push('/home')
    }

    //Go to supplier page
    const handleButtonClickSupplier = () => {
      history.push('/supplier-master')
    }


    //get the value in search and set the setstate
    const handleSearchInput = (e) => {
      setSearchQuery(e.target.value)
      };

     //delete method for remove UOM
   const handleDeleteTable = (id, no) => {
    setShow(true);
    setTableD({id:id,table_no:no})
     
    }

    //close the modal
    const handleCloseConfirmation = () => {
      setShow(false)
    }
    const handleClose = () => {
      setShowCreate(false)
    }
    const handleCreateform = () => {
      setShowCreate(true)
    }
    

    const handleDelete = () => {
      const token = localStorage.getItem('Token');
      axios
      .delete(`${var_api}expense-log/delete/${tableD.id}`,{
        headers: {
            Authorization: token, // Include the token in the Authorization header
        },
    })
      .then((response) => {
        if (response.status === 200) {
            fetchSettlements();
          setShow(false);
          Swal.fire("success"," Settlement Removed Successfully!","success")
          // Perform any other actions you need on success
        } else if (response.status === 404) {
          console.log('Settlement not found');
          Swal.fire("error","Settlement not found!","error")
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error deleting data:", error);
        }
        Swal.fire("error","Failed to Remove Settlement!","error")
        // Handle the error as needed
      });
    }

    //close the update modal
  const handleEditClose = () =>{
    setIsEdit(false);
  };
//to open the form for slot updation 
const handleEditTable = async (data) => {
  console.log("Editing data:", data);
  setIsEdit(true);
  setUpdateFormData({
      id: data.id,
      supplier_id: data.supplier_id,
      supplier_name: data.supplier_name,
      paid_amount: data.paid_amount,
      remarks: data.remarks,
  });
  // Set the selectedSupplier object to match what the Select expects
  setSelectedSupplier({
    value: data.supplier_id,
    label: data.supplier_name
});  // Assuming the supplier name is the one displayed in the dropdown
  console.log("updateFormData:", updateFormData);
};



const handleUpdateSubmit = async (e) => {
  e.preventDefault();

  const token = localStorage.getItem('Token');  // Get the token from localStorage

  const requestData = {
      supplier_id: parseInt(updateFormData.supplier_id),
      paid_amount: updateFormData.paid_amount,
      remarks: updateFormData.remarks,
  };

  try {
      // Make a PUT request to update the expense log
      const response = await axios.put(
          `${var_api}expense-log/put/${updateFormData.id}`, 
          requestData,
          {
              headers: {
                  'Content-Type': 'application/json', // Correct content type
                  Authorization: token,   // Pass the token here
              },
          }
      );

      if (response.status === 200) {
          fetchSettlements();  // Assuming this will reload the updated data
          setIsEdit(false);  // Close the modal

          Swal.fire({
              icon: 'success',
              text: 'Supplier Details updated successfully',
              confirmButtonColor: '#007500',
          });
      } else {
          Swal.fire({
              icon: 'error',
              text: 'Failed to update Supplier Details',
              confirmButtonColor: '#007500',
          });
      }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
      Swal.fire('Error', 'Failed to update Supplier Details. Please try again.', 'error');
  }
};


    return(
      <><Layout>
        {/* <div className='whole' style={{backgroundColor:"white"}}> */}
        
            {/* <div class="split right"> */}
         
      <div style={{border:"none",padding:"20px",width:"100%",height:"640px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
      
      <div>
      <div className="d-flex justify-content-between items-center">
      <h4 className='text-lg font-semibold ushe'>EXPENSE LOG</h4>
  <p className="text-lg font-semibold">
    No. of Settlements: <span className="text-gray-800 font-bold">{tables.length}</span>
  </p>
  <p className="text-lg font-semibold">
    Total Amount: <span className="text-gray-800 font-bold">{getTotalAmount()}</span>
  </p>
  
  <div className="d-flex justify-content-between">
<label className='form-label m-2'>Date:</label>
    <input
      type="date"
      id="yesterdayDateInput"
      className="form-control"
      value={selectedDate}
      onChange={handleDateChange}
    />
  </div>
  
  <Button variant='dark' style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}} onClick={handleCreateform}>
    Create Expense
  </Button>
  {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Supplier</Button>{' '} */}
</div>


<div className="d-flex justify-content-end mt-4 mb-2">
  <input
    className="form-control"
    type="text"
    placeholder="Search"
    style={{ width: "20%" }}
  />
</div>
     <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"100%"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th scope="col">S.No</th>
      <th scope="col">Supplier Name</th>
      <th scope="col">Paid Amount</th>
      <th scope="col">Remarks</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody className="body-half-screen">
  {tables.length > 0 ? (
    tables.map((data, index) => (
      <tr key={data.id} style={{ padding: "5px" }}>
        <th scope="row">{index + 1}</th>
        <td>{data.supplier_name ? data.supplier_name : "-"}</td>
        <td>{data.paid_amount}</td>
        <td>{data.remarks}</td>
        <td>
          <Tooltip
            isOpen={puttooltipOpen[index]}
            target={`putButton${index}`}
            toggle={() => togglePutTooltip(index)}
            placement="left"
          >
            Edit
          </Tooltip>
          <i
            className="bi bi-pencil-square"
            id={`putButton${index}`}
            onClick={() => { handleEditTable(data); togglePutTooltip(index); }}
            style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}
          ></i>{' '}
          <Tooltip
            isOpen={deletetooltipOpen[index]}
            target={`deleteButton${index}`}
            toggle={() => toggleDeleteTooltip(index)}
            placement="right"
          >
            Delete
          </Tooltip>
          <i
            className="bi bi-trash"
            id={`deleteButton${index}`}
            onClick={() => { handleDeleteTable(data.id, data.supplier_name); toggleDeleteTooltip(index); }}
            style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}
          ></i>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center" }}>
        No Data Available
      </td>
    </tr>
  )}
</tbody>


</table>

      </div>
<br/>
<br/>


        </div>
      
      </div>
        
      <Modal
  show={isEdit}
  onHide={handleEditClose}
  backdrop="static"
  keyboard={false}
  size="m"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>EXPENSE LOG UPDATE</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {updateFormData && (
      <form onSubmit={handleUpdateSubmit}>
        <div className='mb-3'>
          <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Supplier</label>
          <Select
            className="form-control"
            name="supplier_id"
            value={selectedSupplier}
            onChange={handleUpdateSupplierSelectChange}
            options={suppliers.map((supplier) => ({
              value: supplier.id,
              label: supplier.supplier_name
            }))}
            placeholder="Select Supplier"
            isSearchable={true}
          />
        </div>

        <div className='mb-3'>
          <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Paid Amount</label>
          <input
            className="form-control"
            type='number'
            name='paid_amount'  // Ensure the name matches the state field
            value={updateFormData.paid_amount}
            onChange={handleUpdatePaidAmountChange}  // Handle the change for paid amount
            placeholder='Enter Paid Amount'
            required
            min="0.1"
            step="0.1"
          />
        </div>

        <div className='mb-3'>
          <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Remarks</label>
          <input
            className="form-control"
            type='text'
            name='remarks'  // Ensure the name matches the state field
            placeholder='Enter Remarks'
            value={updateFormData.remarks}
            onChange={handleUpdateRemarksChange}  // Handle the change for remarks
          />
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button variant="secondary" onClick={handleToReset} className="me-2">
            Reset
          </Button>
          <Button type="submit" variant="success">
            Update
          </Button>
        </div>
      </form>
    )}
  </Modal.Body>
</Modal>

      <Modal show={showCreate} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>EXPENSE LOG CREATE</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={Submit}>
          <div className='mb-3'>
            <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Supplier</label>
            <Select
              className="form-control"
              name="table_no"
              value={selectedSupplier}
              onChange={handleSupplierSelectChange}
              options={suppliers.map((supplier) => ({
                value: supplier.id,
                label: supplier.supplier_name
              }))}
              placeholder="Select Supplier"
              isSearchable={true}
            />
          </div>
          
          <div className='mb-3'>
            <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Paid Amount</label>
            <input
              className="form-control"
              type='number'
              name='no_of_seats'
              value={paidAmount}
              onChange={handlePaidAmountChange}
              placeholder='Enter Paid Amount'
              required
              min="0.1"
              step="0.1"
            />
          </div>
          
          <div className='mb-3'>
            <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Remarks</label>
            <input
              className="form-control"
              type='text'
              placeholder='Enter Remarks'
              value={remarks}
              onChange={handleRemarksChange}
            />
          </div>
          
          <div className="d-flex justify-content-end mt-4">
            <Button variant="secondary" onClick={handleToReset} className="me-2">
              Reset
            </Button>
            <Button type="submit" variant="success">
              Submit
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>

          

      <Modal
         show={show}
         onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        centered
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete supplier Name {tableD.table_no}
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
</Modal>
        {/* </div> */}
        </Layout></>
        
    )
}

export default Settlements;